module.exports = __webpack_public_path__ + "static/media/CLOUD_OPTICAL_THICKNESS_VISUALIZED.9bbd3c5c.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/utils/legend/CLOUD_OPTICAL_THICKNESS_VISUALIZED.PNG
// module id = 1083
// module chunks = 0